export const PageText = {
  _1: 'aircheckr Air Quality Index',
  _2: 'The aircheckr Air Quality Index (AQI) translates the complex set of AQ data from different pollutants to just one easily interpretable value.'
};

export const Categories = {
  _1: {
    title: 'Just like in school',
    subcategories: [
      {
        key: 0,
        subtitle: 'One value',
        text: 'The higher the score, the healthier the air! AQI of 83 is good. AQI of 38 is bad. Depending on your needs, aircheckr can provide AQI in as a score out of 3, 10 or 100.'
      },
      {
        key: 1,
        subtitle: 'One quality name',
        text: 'The aircheckr air quality index also links to a quality name (“good”, “moderate”, “bad” and “very bad”)'
      },
      {
        key: 2,
        subtitle: 'One colour',
        text: 'The colour is handy at describing the air quality at a glance. And just like in school - red is bad.'
      }
    ]
  },
  _2: {
    title: 'How does it work?',
    subcategories: [
      {
        key: 0,
        subtitle: 'The worst pollutant decides',
        text: 'The hourly mean concentrations of the 4 most important pollutants are scaled according to the table above. The overall aircheckr AQI is taking the values of the worst pollutant(s). In the figure below, NO<sub>2</sub> is the worst pollutant in the morning, and hence defining the AQI. Just before noon ozone becomes worse, making the aircheckr AQI drop again.'
      }
    ]
  },
  _3: {
    title: 'Recommendations',
    subcategories: [
      {
        key: 0,
        subtitle: 'But we do not stop there',
        text: 'We provide personalized recommendations, that empower your customers to take action. And as many small acts add up to a big difference, you can also integrate tips from aircheckr and provide people with tools and information to take action themselves!'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/air-quality-index_page.js